import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { colors } from '../../constants/theme';

export const HeaderWrapper = styled(Box)(({ theme }) => ({
  color: colors.accent,
  padding: '10px 20px',
  marginBottom: '20px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '10px 16px',
    marginBottom: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '8px 12px',
    marginBottom: '12px',
  },
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: '3rem',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.25rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.75rem',
  },
}));

export const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  opacity: 0.8,
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}));
